import { render } from "./PagesControll.vue?vue&type=template&id=157c6b31"
import script from "./PagesControll.vue?vue&type=script&lang=js"
export * from "./PagesControll.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__